import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { NbThemeModule, NbLayoutModule, NbCardModule, NbDatepickerModule } from '@nebular/theme';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CercadorEsplaisModule } from './cercador-esplais/cercador-esplais.module';
import { CercadorActivitatsModule } from './cercador-activitats/cercador-activitats.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CercaService } from './cerca.service';
import { registerLocaleData } from '@angular/common';
import localeCat from '@angular/common/locales/ca';

// the second parameter 'fr' is optional
registerLocaleData(localeCat, 'ca');

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CercadorEsplaisModule,
    CercadorActivitatsModule,
    NbLayoutModule,
    NbCardModule,
    BrowserAnimationsModule,
    NbThemeModule.forRoot({ name: 'default' }),
    NbDatepickerModule.forRoot(),
  ],
  providers: [CercaService, {provide: LOCALE_ID, useValue: 'ca' }],
  bootstrap: [AppComponent]
})
export class AppModule { }
